import { FC, useState } from "react"
import { LowerInfoProps, LongShortStatistics, MIN_INFO_WIDTH, useResize } from "@root/common"
import { observer } from "mobx-react-lite"
import OrderBookPanel from "./OrderBookPanel"

interface ILowerInfo {
    statistics?: LongShortStatistics
}

const LowerInfo: FC<LowerInfoProps> = observer((props) => {
    const { statistics } = props as ILowerInfo
    const [isMobileLayout, setIsMobileLayout] = useState(
      () => window.innerWidth <= 2 * parseInt(MIN_INFO_WIDTH)
    )

    useResize(() => {
      setIsMobileLayout(window.innerWidth <= 2 * parseInt(MIN_INFO_WIDTH))
    }, [])

    if (isMobileLayout) {
        return null
    }

    return <OrderBookPanel statistics={statistics} />
})

export default LowerInfo
